import axios from "axios";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";

import Loader from "../../Layout/Loader";
import Input from "../Main/Input";

function Ibcc({ setChooseBox, qrData }) {
  const [loading, setLoading] = useState(false);
  const [path, setPath] = useState("");
  const [text, setText] = useState("");

  const handleForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {};
    // form data format
    e.target.querySelectorAll("input").forEach((item) => {
      formData[item.name] = item.value;
    });
    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND + "/record", formData);
      setPath(response.data.data);
      const comp = /intermediate/i.test(formData["Certificate/Program"]) ? "Inter" : /matric/i.test(formData["Certificate/Program"]) ? "Matric" : "";
      setText({
        refCode: formData["Reference No"].split("-")[1],
        degree: `${formData["Certificate/Program"].split("/")[0].trim()}${comp && "/" + comp}`,
      });

      window.location.href = "#";
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleReset = () => {
    document.querySelector("form").reset();
  };
  useEffect(() => {

    setPath(qrData.path);
    setText({
      refCode: qrData.refCode,
      degree: qrData.degree,
    });
  }, [qrData]);

  return (
    <>
      {loading && <Loader />}
      <div className="home-container">
        <div className="home-main">
          <div className="logo">
            <img src="/logo.png" alt="" />
          </div>
          <h1>Welcome to IBCC Portal for Digital Verification</h1>
          <h3>Please Fill this Form To Generate QR</h3>
        </div>

        {path && (
          <div className="qr-code-main">
            <QRCodeSVG value={process.env.REACT_APP_QR_PREFIX + path} size={"100%"} />
            <div className="text">
              <p className="uppercase">Inter Boards Coordination Commission (Ibcc)</p>
              <strong>{text.refCode}</strong>
              <p style={{ textTransform: "unset" }}>{text.degree}</p>
            </div>
          </div>
        )}
        {path && <button onClick={handlePrint}>Print</button>}
        <form className="form" onSubmit={handleForm}>
          <Input label="Student Name" name="Student Name" pattern="" placeholder="Student Name" key="Student Name" />
          <Input label="Father Name" name="Father Name" pattern="" placeholder="Father Name" key="Father Name" />
          <Input label="Roll No" name="Roll No" pattern="" placeholder="Roll No" key="Roll No" />
          <Input label="Certificate/Program" name="Certificate/Program" pattern="" placeholder="Certificate/Program" key="Certificate/Program" />
          <Input label="Board" name="Board" pattern="" placeholder="Board" key="Board" />
          <Input label="Group" name="Group" pattern="" placeholder="Group" key="Group" />
          <Input label="Passing Year - Session" name="Passing Year - Session" pattern="" placeholder="Passing Year - Session" key="Passing Year - Session" />
          <Input label="Marks" name="Marks" pattern="" placeholder="Marks" key="Marks" />
          <Input label="Reference No" name="Reference No" pattern="" placeholder="Reference No." key="Reference No." />
          <button type="submit">Submit</button>
        </form>
        <button className="reset-button" onClick={handleReset}>
          Reset
        </button>
        <button className="done-button" onClick={() => setChooseBox("")}>
          Done
        </button>
      </div>
    </>
  );
}

export default Ibcc;
